import Api from './api';

const yardsListRequest = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/yards', {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}

const createYardRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/yards/', data, { headers: { Authorization: 'Bearer ' + access_token } })
}

const deleteYardRequest = (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().delete('/api/yards/' + id, { headers:
        {
            Authorization: 'Bearer ' + access_token,
            'Content-Type': 'application/x-www-form-urlencoded'
        }

    })
}


export default { yardsListRequest, createYardRequest, deleteYardRequest }



// WEBPACK FOOTER //
// ./src/api/apiYards.js